import { render, staticRenderFns } from "./MonthlySwiper.vue?vue&type=template&id=2f2fed66&scoped=true&"
import script from "./MonthlySwiper.vue?vue&type=script&lang=js&"
export * from "./MonthlySwiper.vue?vue&type=script&lang=js&"
import style0 from "./MonthlySwiper.vue?vue&type=style&index=0&id=2f2fed66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2fed66",
  null
  
)

export default component.exports